export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            有建议、反馈或合作意向？欢迎通过以下方式与我们取得联系
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
            <div className="p-6 rounded-2xl bg-background-50 border border-background-200/70 text-center">
              <span className="w-12 h-12 rounded-xl bg-primary-100 text-primary-600 flex items-center justify-center mx-auto mb-4">
                <i className="ri-mail-line text-xl"></i>
              </span>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-2">投稿邮箱</h3>
              <p className="text-xs text-foreground-500 break-all">contact@hanmanwu.com</p>
            </div>

            <div className="p-6 rounded-2xl bg-background-50 border border-background-200/70 text-center">
              <span className="w-12 h-12 rounded-xl bg-accent-100 text-accent-600 flex items-center justify-center mx-auto mb-4">
                <i className="ri-discuss-line text-xl"></i>
              </span>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-2">意见反馈</h3>
              <p className="text-xs text-foreground-500">在评论区留下你的建议，我们会认真阅读每一条反馈</p>
            </div>

            <div className="p-6 rounded-2xl bg-background-50 border border-background-200/70 text-center">
              <span className="w-12 h-12 rounded-xl bg-secondary-100 text-secondary-600 flex items-center justify-center mx-auto mb-4">
                <i className="ri-briefcase-line text-xl"></i>
              </span>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-2">商务合作</h3>
              <p className="text-xs text-foreground-500">欢迎漫画作者、版权方洽谈合作，共创优质内容生态</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}